/* app/js/src/components/channel/channel-preview/channel-preview.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container {
  width: 342px;
  height: 235px;
  position: fixed;
  right: 20px;
  bottom: 29px;
  background-color: #ffffff;
  z-index: 10;
  opacity: 0;
  transition: opacity ease-in 0.2s;
  pointer-events: none;
  -webkit-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
}
.container.show {
  opacity: 1;
  pointer-events: initial;
}
.container header {
  height: 43px;
}
.container header .topHeader {
  height: 24px;
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
  position: relative;
  padding: 6px;
  line-height: 12px;
  background-color: #141b22;
  cursor: all-scroll;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container header .topHeader .icons {
  position: absolute;
  right: 6px;
  top: 6px;
  font-size: 0;
  z-index: 3;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container header .topHeader .icons .close {
  display: inline-block;
  cursor: pointer;
}
.container header .topHeader .icons .close svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.container header .topHeader .icons .close svg:hover path {
  -ms-transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
.container header .topHeader .icons .enlarge {
  display: inline-block;
  cursor: pointer;
  margin-right: 9px;
}
.container header .topHeader.active::before {
  content: " ";
  background-color: transparent;
  position: absolute;
  left: -100%;
  top: -300%;
  width: 300%;
  height: 1600%;
  z-index: 3;
}
.container header .bottomHeader {
  height: 19px;
  font-size: 10px;
  color: #ffffff;
  position: relative;
  padding: 4.5px 6px;
  background-color: #232f3a;
  line-height: 9px;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container header .bottomHeader .time {
  position: absolute;
  right: 6px;
  top: 6px;
  cursor: default;
  opacity: 0;
}
.container section {
  height: 192px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container section video {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
}
video::-webkit-media-controls-enclosure {
  display: none !important;
}
.custom-video-controls {
  z-index: 2147483648 !important;
  height: 40px;
  background-color: #eef2f6;
  display: flex;
  flex-direction: column;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  pointer-events: auto;
}
.quality-settings-fullscreen {
  z-index: 9999999999;
  height: 150px;
  width: 100px;
  background-color: black;
  padding: 15px;
  bottom: 40px;
  right: 0px;
  margin: 0 10px 10px 0;
  position: absolute;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.quality-settings-fullscreen:hover {
  cursor: pointer;
}
.single-quality-container {
  display: flex;
  justify-content: flex-start;
}
.success {
  line-height: 31px;
  width: 18px;
  height: 18px;
}
.success ::ng-deep svg {
  width: 18px;
  height: 18px;
}
.success ::ng-deep svg path {
  fill: white !important;
}
.controls {
  display: flex;
  justify-content: space-between;
}
.controls-left {
  display: flex;
}
.controls-right {
  display: flex;
}
.play {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.play:hover {
  cursor: pointer;
}
.play:hover ::ng-deep svg g g {
  fill: #93a9bf !important;
}
.play ::ng-deep svg {
  width: 20px;
  height: 20px;
}
.sound {
  margin-top: 1px;
  margin-right: 10px;
  margin-left: 2.5px;
  width: 16px;
  height: 16px;
}
.sound:hover {
  cursor: pointer;
}
.sound:hover ::ng-deep svg path {
  fill: #93a9bf !important;
}
.sound ::ng-deep svg {
  width: 16px;
  height: 16px;
}
.sound ::ng-deep svg path {
  fill: #232f3a !important;
}
.muted {
  margin-right: 10px;
  width: 18px;
  height: 18px;
}
.muted:hover {
  cursor: pointer;
}
.muted:hover ::ng-deep svg path {
  fill: #93a9bf !important;
}
.muted ::ng-deep svg {
  width: 18px;
  height: 18px;
}
.muted ::ng-deep svg path {
  fill: #232f3a !important;
}
.settings {
  width: 20px;
  height: 20px;
}
.settings:hover {
  cursor: pointer;
}
.settings:hover ::ng-deep svg g g {
  fill: #93a9bf !important;
}
.settings ::ng-deep svg {
  width: 20px;
  height: 20px;
}
.settings ::ng-deep svg g g {
  fill: #232f3a !important;
}
.fullscreen {
  margin-left: 10px;
  width: 18px;
  height: 18px;
}
.fullscreen:hover {
  cursor: pointer;
}
.fullscreen:hover ::ng-deep svg path {
  fill: #93a9bf !important;
}
.fullscreen ::ng-deep svg {
  width: 18px;
  height: 18px;
}
.fullscreen ::ng-deep svg path {
  fill: #232f3a !important;
}
.quality {
  font-family: "Open Sans";
  font-size: 12px;
  color: white;
  margin-left: 3px;
}
.fullscreen-container {
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=channel-preview.component.css.map */
